/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export enum PlatformSubscriptionType {
  connect = 'connect',
  connectMemory = 'connect-memory',
  datastore = 'datastore',
  datastoreRequests = 'datastore-requests',
  funnelback = 'funnelback',
  funnelbackDocuments = 'funnelback-documents',
  funnelbackPremium = 'funnelback-premium',
  funnelbackPremiumDedicated = 'funnelback-premium-dedicated',
  funnelbackPremiumMultiTenanted = 'funnelback-premium-multi-tenanted',
  matrix = 'matrix',
  matrixPremium = 'matrix-premium',
  matrixPremiumDedicated = 'matrix-premium-dedicated',
  matrixRequests = 'matrix-requests',
  unknown = 'unknown',
}
